"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { DEFAULT_PULL_UPDATES_INTERVAL_SECONDS, DEFAULT_FULL_SYNC_INTERVAL_SECONDS, IntegrationElementLevel } from '@membranehq/sdk';
import { AdvancedOptions } from '../../AdvancedOptions.mjs';
import { SimpleInput } from '../../SimpleInput/SimpleInput.mjs';
import '../../DataBuilderUI/FieldControlPanel/index.mjs';
import '../../DataBuilderUI/ActionBar.mjs';
import '../../DataBuilderUI/Cell.mjs';
import 'clsx';
import '../../DataBuilderUI/styles.module.css.mjs';
import '../../DataBuilderUI/Row.mjs';
import '../../DataBuilderUI/Title.mjs';
import '../../Textarea/index.mjs';
import '../../SimpleInput/recipe.mjs';
import { useIntegrationElementContext } from '../use-integration-element.mjs';
import { DataCollectionSelect } from './DataCollectionSelect.mjs';
import { UdmSelect } from './UdmSelect.mjs';

function DataSourceConfig(props) {
  return /* @__PURE__ */ jsx("div", { className: "flex flex-col gap-2 mb-2", children: /* @__PURE__ */ jsx(LevelSpecificDataSourceConfig, { ...props }) });
}
function LevelSpecificDataSourceConfig(props) {
  const { level } = useIntegrationElementContext();
  const { value, onChange, configureEvents } = props;
  function patchValue(patch) {
    onChange({
      ...value ?? {},
      ...patch
    });
  }
  switch (level) {
    case IntegrationElementLevel.UNIVERSAL:
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(UdmSelect, { value: value?.udm, onChange: (udm) => patchValue({ udm }) }),
        /* @__PURE__ */ jsx(AdvancedOptions, { children: configureEvents && /* @__PURE__ */ jsx(DataSourceConfigureEvents, { value, onChange }) })
      ] });
    case IntegrationElementLevel.CONNECTOR:
    case IntegrationElementLevel.CONNECTION:
      return /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          DataCollectionSelect,
          {
            value,
            onChange: (value2) => patchValue(value2),
            variablesSchema: props.variablesSchema
          }
        ),
        configureEvents && /* @__PURE__ */ jsx(AdvancedOptions, { openByDefault: !!(value?.pullUpdatesIntervalSeconds ?? value?.fullSyncIntervalSeconds), children: /* @__PURE__ */ jsx(DataSourceConfigureEvents, { value, onChange }) })
      ] });
    default:
      return null;
  }
}
function DataSourceConfigureEvents({
  value,
  onChange,
  readOnly
}) {
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx("p", { children: "Change how often we pulls updates from the data source." }),
    /* @__PURE__ */ jsx(
      SimpleInput,
      {
        label: "Pull updates interval (seconds)",
        placeholder: `Default: ${DEFAULT_PULL_UPDATES_INTERVAL_SECONDS}`,
        value: value?.pullUpdatesIntervalSeconds?.toString(),
        disabled: readOnly,
        onChange: (pullUpdatesIntervalSeconds) => onChange({
          ...value,
          pullUpdatesIntervalSeconds: Number(pullUpdatesIntervalSeconds)
        })
      }
    ),
    /* @__PURE__ */ jsx(
      SimpleInput,
      {
        label: "Full sync interval (seconds)",
        placeholder: `Default: ${DEFAULT_FULL_SYNC_INTERVAL_SECONDS}`,
        value: value?.fullSyncIntervalSeconds?.toString(),
        disabled: readOnly,
        onChange: (fullSyncIntervalSeconds) => onChange({
          ...value,
          fullSyncIntervalSeconds: Number(fullSyncIntervalSeconds)
        })
      }
    )
  ] });
}

export { DataSourceConfig, DataSourceConfigureEvents };
